var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.538 318.538",
    style: {
      enableBackground: "new 0 0 318.538 318.538"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3233"
    },
    d: "M69.573,236.836c0,0-1.012-23.123-1.557-57.932c-0.506-32.442,0.073-60.422,0.624-100.721 C69.163,39.867,91.33,0,157.946,0c58.319,0,72.135,26.653,69.364,44.841c0,0,8.813,0.781,13.467,6.835 c7.891,10.269,7.807,47.348,7.172,85.113c-1.248,74.074-1.602,100.047-1.602,100.047H69.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151"
    },
    d: "M295.387,253.091c-10.522-37.754-63.361-33.566-86.164-44.408s-19.245-47.219-22.134-53.548 h-55.638c-2.889,6.329,0.674,42.711-22.134,53.548c-22.803,10.842-75.642,6.655-86.164,44.408 c-5.806,20.824-5.525,27.187-7.133,50.26c0,0,72.5,15.187,141.611,15.187s144.888-15.187,144.888-15.187 C300.917,280.278,301.193,273.915,295.387,253.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393C3D"
    },
    d: "M179.759,216.995c22.803,10.842,75.642,6.655,86.164,44.408c5.531,19.83,5.542,26.552,6.913,47.073 c18.155-2.816,29.682-5.126,29.682-5.126c-1.602-23.067-1.326-29.435-7.133-50.26c-10.522-37.754-63.361-33.566-86.164-44.408 c-22.803-10.842-19.245-47.219-22.134-53.548h-29.456C157.631,155.135,156.951,206.159,179.759,216.995z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#393C3D"
    },
    points: "58.011,276.079 107.248,269.829 159.272,313.996 109.918,257.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#393C3D"
    },
    points: "260.511,276.079 211.28,269.829 159.255,313.996 208.604,257.104  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE5DC"
    },
    d: "M260.511,276.079c-10.404-21.853-23.77-44.195-50.097-66.852c-0.41-0.18-0.815-0.36-1.208-0.545 c-6.396-3.041-10.713-8.088-13.686-13.917h-28.356h-15.8h-28.356c-2.973,5.829-7.29,10.876-13.686,13.917 c-0.393,0.185-0.798,0.371-1.208,0.545c-26.327,22.657-39.693,44.999-50.097,66.852l50.591-12.472l50.664,50.389l50.653-50.389 L260.511,276.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DBD3"
    },
    d: "M210.414,209.227c-0.41-0.18-0.815-0.36-1.208-0.545c-6.396-3.041-10.713-8.088-13.686-13.917 h-28.356h-3.755c3.266,9.724,8.369,18.441,16.35,22.235c12.326,5.857,33.42,7.329,51.867,13.4 C225.618,223.374,218.649,216.321,210.414,209.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8C59E"
    },
    d: "M199.291,200.678c-11.803-14.951-9.836-40.356-12.202-45.549h-55.638 c-2.372,5.193-0.405,30.599-12.202,45.549c4.721,53.171,40.024,113.312,40.024,113.312S194.48,254.378,199.291,200.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB58E"
    },
    d: "M179.759,216.995c4.44,2.113,10.022,3.653,16.204,5.042c1.534-7.121,2.698-14.293,3.333-21.364 c-11.803-14.951-9.836-40.356-12.202-45.549h-29.458C157.631,155.135,156.951,206.159,179.759,216.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCA281"
    },
    d: "M123.969,192.731c9.229,7.959,20.054,15.85,35.241,18.132 c15.237-2.288,26.023-10.342,35.269-18.334c-7.689-14.973-5.311-32.83-7.391-37.4H131.45 C129.365,159.704,131.692,177.752,123.969,192.731z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.177 0.9842 -0.9842 -0.177 380.0948 -81.5728)",
    style: {
      fill: "#DDB58E"
    },
    cx: 224.153,
    cy: 118.132,
    rx: 21.386,
    ry: 11.629
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9842 0.177 -0.177 -0.9842 207.8496 217.7334)",
    style: {
      fill: "#E8C59E"
    },
    cx: 94.213,
    cy: 118.137,
    rx: 11.629,
    ry: 21.386
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8C59E"
    },
    d: "M219.643,46.938l-59.91,9.218c0,0-21.229,0.922-38.552,9.729 c-15.901,8.088-28.002,23.91-28.159,28.378c-1.551,44.156,7.464,104.645,66.171,113.48 C253.524,193.551,219.643,46.938,219.643,46.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB58E"
    },
    d: "M159.194,207.744c94.331-14.192,60.45-160.806,60.45-160.806h-14.141 c3.873,61.242,9.229,93.774-13.006,129.24C174.881,204.281,159.194,207.744,159.194,207.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB58E"
    },
    d: "M217.401,40.407c0,0-32.701,15.721-81.51,14.883c-43.031-0.736-42.464,36.146-42.84,38.636 c0,0,10.033-18.593,38.012-23.685c25.422-4.626,45.662,3.114,63.839,4.822c20.223,1.9,26.968-13.445,26.968-13.445 L217.401,40.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3233"
    },
    d: "M215.664,34.404c0,0-30.975,18.171-79.773,16.733c-52.154-1.54-43.11,41.654-42.84,42.795 c0,0,5.379-20.24,33.089-26.76c17.992-4.232,35.286-2.552,53.222,1.006c40.339,8.004,43.897-15.918,43.897-15.918 S225.286,42.941,215.664,34.404z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CC7D2E"
    },
    cx: 228.22,
    cy: 134.917,
    r: 4.367
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CC7D2E"
    },
    cx: 90.38,
    cy: 134.917,
    r: 4.367
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.3c3d4c2f2f4ea3a96af3720dc3f54756.svg";
export { ForwardRef as ReactComponent };